/**
 * @type {Array<string>}
 */
export const availableSizes = ['normal', 'small', 'large'] as const

export type AvailableSizes = (typeof availableSizes)[number]

/**
 * @type {Array<string>}
 */
export const availableColors = [
  'white',
  'green',
  'yellow',
  'blue',
  'dark-blue',
  'gray',
  'teal',
] as const

export type AvailableColors = (typeof availableColors)[number]

/**
 * @type {Array<string>}
 */
export const availableColorsNoWhite = availableColors.filter(
  (color) => color !== 'white',
)

/**
 * @type {Array<string>}
 */
export const availableTextColors = availableColors.map(
  (color) => `text-${color}`,
)

/**
 * Common date formats used across components
 * @type {object}
 */
export const DATE_FORMATS = {
  // European/German format (default)
  EUROPEAN: 'dd.mm.yy' as const,
  EUROPEAN_SHORT: 'D.M.YY' as const,

  // US format
  US: 'mm/dd/yy' as const,
  US_SHORT: 'M/D/YY' as const,

  // ISO-like format
  ISO_LIKE: 'yy/mm/dd' as const,
  ISO_LIKE_SHORT: 'YY/M/D' as const,
} as const
